export default __webpack_public_path__ + "static/media/563.4a312c78.gif";